import { useQuery } from "@/api/swr/useQuery";
import { answerSubCategoryWithNavSchema } from "@/schema/app/assessment/answerSubCategoryDetail";

type Config = Parameters<
  typeof useQuery<typeof answerSubCategoryWithNavSchema>
>[2];

export function useGetAnswerSubCategory(
  subCategoryId: string,
  config?: Config,
) {
  return useQuery(
    answerSubCategoryWithNavSchema,
    `/app/assessment/answer_sub_categories/${subCategoryId}`,
    config,
  );
}